import React from 'react';
import { Box, Flex, TextHeadingFour } from '@cko/primitives';
import styled from 'styled-components';
import { Divider } from '../Divider';
export const Section = styled(Flex).attrs({
    as: 'section',
}) `
  flex-direction: column;
  margin-bottom: var(--layout-sofa);
  width: 100%;
`;
export const SectionWithTitle = ({ children, hideDivider = false, rightElement, subTitle, title, ...rest }) => {
    // In absence of Divider which already adds air between components, it adds some margin.
    const marginBottomForDivider = hideDivider ? 'var(--layout-soybean)' : undefined;
    const marginBottom = subTitle ? undefined : marginBottomForDivider;
    return (React.createElement(Section, { as: "section", ...rest },
        React.createElement(Flex, { justifyContent: "space-between", alignItems: "flex-start" },
            React.createElement(Box, null,
                React.createElement(TextHeadingFour, { marginBottom: marginBottom }, title),
                subTitle && React.createElement(Box, { marginBottom: "var(--layout-spoon)" }, subTitle)),
            rightElement),
        !hideDivider && React.createElement(Divider, { "data-testid": "section-divider" }),
        children));
};
